<template>
  <div>
    <van-popup v-model="isShow" position="bottom" @click-overlay="onCancel">
      <van-picker show-toolbar :columns="list" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ['list', 'codeList', 'show', 'type'],
  data() {
    return {
      isShow: this.show
    }
  },
  methods: {
    onCancel() {
      this.isShow = false
      this.$emit('cancel', this.isShow)
    },
    onConfirm(value, index) {
      this.isShow = false
      this.$emit('cancel', this.isShow)
      let data = {}
      data = {
        name: value,
        code: this.codeList[index]
      }
      this.$emit('change', data)
    }
  }
}
</script>
